import m from "../../geodata/es2015/tunisiaLow";
window.am4geodata_tunisiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tunisiaLow.js
// module id = null
// module chunks = 